import React, { useState, useEffect } from 'react'
import queryString from 'query-string'
import CheckAuth from '../../../elements/checkAuth';
import axios from 'axios';
import config from '../../../../../config/environment';
import '../../../../../styles/table.admin.css';
import Menu from '../../../elements/Menu/menu';
import './transactionCheck.css';
import PageMode from '../../../elements/PageMode/pageMode';
import ItemTable from '../elements/ItemTable';
import ModalWindow from '../../../elements/ModalWindow/modal';
import ItemHeader from '../elements/ItemHeader';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Icon from '../../../../elements/Icon/Icon';

const MODES = ['ETH', 'BTC', 'LTC', 'DOGE', 'BTG', 'BCH', 'BSV', 'XVG', 'BNBSMART', 'TRX'];

export default function TransactionCheck() {

    const url = window.location.href
    const urlParamsString = url.slice((url.indexOf('?')) + 1)
    const urlParamsObj = queryString.parse(urlParamsString)

    const [state, setState] = useState({
        mode: 'ETH',

        txHash: null,
        fromAddress: null,
        cashbackToken: null,
        parentCashbackToken: null,

        transactionsArray: [],
        pages: 0,
        activePage: 1
    });

    const [modalState, setModal] = useState(null);

    const modeOnChangeHandler = async (event) => {
        const currencyCode = event.target.value;
        const transactionsData = await getTransactionsData(currencyCode, {
            txHash: state.txHash,
            fromAddress: state.fromAddress,
            cashbackToken: state.cashbackToken,
            parentCashbackToken: state.parentCashbackToken
        });

        setState({
            ...state,
            mode: currencyCode,
            transactionsArray: transactionsData.transactionsArray,
            pages: transactionsData.pages,
            activePage: 1
        });
    };

    useEffect(() => {
        const main = async () => {
            let transactionsData
            if (urlParamsObj.currencyCode && (urlParamsObj.txHash || urlParamsObj.fromAddress || urlParamsObj.cashbackToken
                || urlParamsObj.parentCashbackToken || urlParamsObj.page)) {
                const data = {
                    txHash: urlParamsObj.txHash || null,
                    fromAddress: urlParamsObj.fromAddress || null,
                    cashbackToken: urlParamsObj.cashbackToken || null,
                    parentCashbackToken: urlParamsObj.parentCashbackToken || null,
                    page: urlParamsObj.page || 1
                }
                transactionsData = await getTransactionsData(urlParamsObj.currencyCode, data);
                setState(state => {
                    return {
                        ...state,
                        txHash: urlParamsObj.txHash || null,
                        fromAddress: urlParamsObj.fromAddress || null,
                        cashbackToken: urlParamsObj.cashbackToken || null,
                        parentCashbackToken: urlParamsObj.parentCashbackToken || null,
                        mode: urlParamsObj.currencyCode,
                        transactionsArray: transactionsData.transactionsArray,
                        pages: transactionsData.pages
                    }
                });
            } else {
                transactionsData = await getTransactionsData(state.mode);
                setState(state => {
                    return {
                        ...state,
                        transactionsArray: transactionsData.transactionsArray,
                        pages: transactionsData.pages
                    }
                });
            }

        };
        main();
    }, []);

    const getTransactionsData = async (currencyCode, filters = {}) => {
        try {
            let params = '?currencyCode=' + currencyCode + '&';

            if (filters.txHash) { params += 'txHash=' + filters.txHash + '&'; }
            if (filters.fromAddress) { params += 'fromAddress=' + filters.fromAddress + '&'; }
            if (filters.cashbackToken) { params += 'cashbackToken=' + filters.cashbackToken + '&'; }
            if (filters.parentCashbackToken) { params += 'parentCashbackToken=' + filters.parentCashbackToken + '&'; }
            if (filters.page) { params += 'page=' + filters.page + '&'; }
            else { params += 'page=1&'; }

            const response = await axios.get(config.backendUrl + '/ksu-crypto/transaction-check' + params.slice(0, -1), {
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem('jwtToken')
                }
            });

            // console.log(response.data); // for debugging
            return response.data;

        } catch (error) {
            console.log(error.message);
            console.log(error.response.data.message);
            alert(error.message);
        }
    };

    const moreInfoButtonHandler = (item) => {
        item ?
            setModal(modalState => {
                return {
                    ...modalState,
                    isShowModal: true,
                    item: item
                };
            })
            :
            setModal(modalState => { return { ...modalState, isShowModal: false, item: null }; });
    }

    const searchButtonHandler = async (page = null) => {

        const transactionsData = await getTransactionsData(state.mode, {
            txHash: state.txHash,
            fromAddress: state.fromAddress,
            cashbackToken: state.cashbackToken,
            parentCashbackToken: state.parentCashbackToken,
            page: typeof page === 'object' ? 1 : page
        });

        let newUrl = url.slice(0, (url.indexOf('?') !== -1 ? url.indexOf('?') : url.length))

        if (state.mode) {
            newUrl += `?currencyCode=${state.mode}`
        }
        if (state.txHash) {
            newUrl += `&txHash=${state.txHash}`
        }
        if (state.fromAddress) {
            newUrl += `&fromAddress=${state.fromAddress}`
        }
        if (state.cashbackToken) {
            newUrl += `&cashbackToken=${state.cashbackToken}`
        }
        if (state.parentCashbackToken) {
            newUrl += `&parentCashbackToken=${state.parentCashbackToken}`
        }

        window.history.pushState(null, ``, newUrl);

        setState({
            ...state,
            transactionsArray: transactionsData.transactionsArray,
            pages: transactionsData.pages,
            activePage: typeof page === 'object' ? 1 : page
        });

        window.scrollTo(0, 0)

    }

    const cleanSearchHandler = async (page = null) => {
        const transactionsData = await getTransactionsData(state.mode)
        setState({
            ...state,
            mode: state.mode,
            txHash: null,
            fromAddress: null,
            cashbackToken: null,
            parentCashbackToken: null,
            transactionsArray: transactionsData.transactionsArray,
            pages: transactionsData.pages,
            activePage: page || 1
        });

        let newUrl = url.slice(0, (url.indexOf('?') !== -1 ? url.indexOf('?') : url.length))
        window.history.pushState(null, ``, newUrl);
    }

    const inputChangeHandler = (paramName) => (event) => {
        const newState = { ...state };
        newState[paramName] = event.target.value;
        setState(newState);
    };

    const renderModal = () => {
        if (!modalState || !modalState.item) { return; }
        const data = Object.entries(modalState.item)

        let jsonobj = modalState.item.setInputsOutputs && { 'setInputsOutputs': JSON.parse(modalState.item.setInputsOutputs) }

        return (
            <>
                <ModalWindow show={modalState.isShowModal} close={moreInfoButtonHandler} headerText={'Info'}>
                    <div className="orderInfo__modal_header">Additional info</div>
                    {data.map((item) => {
                        if (item[0] === 'setInputsOutputs' && (state.mode === 'ETH' || state.mode === 'TRX' || state.mode === 'BNBSMART')) {
                            return false
                        }

                        if (item[0] === 'setInputsOutputs') {
                            return (
                                <>
                                    <b>{`${item[0]}:`}</b>
                                    <textarea style={{ width: '100%', minHeight: '100%', border: 'none', fontSize: 16 }}>
                                        {JSON.stringify(jsonobj, null, 2)}
                                    </textarea>
                                </>
                            )
                        }

                        return (
                            <div className="orderInfo__modal_marginBottom5"><b>{`${item[0]}:`}</b> {item[1]}</div>
                        )
                    })}
                </ModalWindow>
            </>
        );
    };

    const deleteFromSearch = (item) => {
        setState({
            ...state,
            [item]: null
        })
        const btn = document.getElementById('search')
        setTimeout(async () => btn.click(), 0)
    }

    const renderTable = () => {

        if (!state.transactionsArray.length && (state.txHash || state.fromAddress || state.cashbackToken || state.parentCashbackToken)) {
            return (
                <div style={{ textAlign: 'center', padding: 15 }} >{`По данному запросу ничего не найдено`}</div>
            )
        }

        if (!state.transactionsArray.length) return

        let keysArray = Object.keys(state.transactionsArray[0]);

        const keys = ['createdAt', 'txStatus', 'logCashback', 'txCurrencyCode', 'txRaw', 'selectedFee', 'confirmedTime']

        if (state.mode === 'ETH') {
            keys.push('setNonce')
        }

        keysArray = keysArray.filter(item => keys.includes(item))
        keysArray = [...keysArray.slice(0, 3), 'txAddress', 'txHashes', ...keysArray.slice(3, keysArray.length)]
        keysArray.push('moreInfo')
        return (
            <>
                <div style={{ textAlign: 'center', padding: 15 }} >{`К-во на странице: ${state.transactionsArray.length}`}</div>
                {(state.txHash || state.fromAddress || state.cashbackToken || state.parentCashbackToken) &&
                    <div style={{ textAlign: 'center', padding: 15, wordBreak: 'break-all' }}>
                        {`Параметры запроса:`} <br />
                        {state.txHash &&
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                                <div style={{ padding: 5 }}>
                                    <b>{'txHash:'}</b> {state.txHash}
                                </div>
                                <div className="closeBtn"
                                    onClick={() => {
                                        deleteFromSearch('txHash')
                                    }}>
                                    <Icon icon={'CLOSE'} size={14} />
                                </div>
                            </div>
                        }
                        {state.fromAddress &&
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                                <div style={{ padding: 5 }}>
                                    <b>{'fromAddress:'}</b> {state.fromAddress}
                                </div>
                                <div className="closeBtn"
                                    onClick={() => {
                                        deleteFromSearch('fromAddress')
                                    }}>
                                    <Icon icon={'CLOSE'} size={14} />
                                </div>
                            </div>
                        }
                        {state.cashbackToken &&
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                                <div style={{ padding: 5 }}>
                                    <b>{'cashbackToken:'}</b> {state.cashbackToken}
                                </div>
                                <div className="closeBtn"
                                    onClick={() => {
                                        deleteFromSearch('cashbackToken')
                                    }}>
                                    <Icon icon={'CLOSE'} size={14} />
                                </div>
                            </div>
                        }
                        {state.parentCashbackToken &&
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                                <div style={{ padding: 5 }}>
                                    <b>{'parentCashbackToken:'}</b> {state.parentCashbackToken}
                                </div>
                                <div className="closeBtn"
                                    onClick={() => {
                                        deleteFromSearch('parentCashbackToken')
                                    }}>
                                    <Icon icon={'CLOSE'} size={14} />
                                </div>
                            </div>
                        }
                    </div>
                }
                <div className="transactionCheckETH__table_wrapper">
                    <table className="table">
                        <thead>
                            <tr>
                                {
                                    keysArray.map((key, index) => {
                                        return (
                                            <ItemHeader key={index} item={key} tooltip />
                                        );
                                    })
                                }
                                {window.screen.width < 700 && <ItemHeader item={'txStatus'} />}
                            </tr>
                        </thead>
                        <tbody>
                            {
                                state.transactionsArray.map((tx, index) => {
                                    // console.log(tx)
                                    return (
                                        <>
                                            <ItemTable item={tx} key={index} keysArray={keysArray} mode={MODES} moreInfoButtonHandler={moreInfoButtonHandler}
                                                setState={setState} state={state} />
                                        </>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
            </>
        );
    };

    const renderPages = () => {
        if (!state.pages) { return; }

        const resData = [];

        for (let i = 1; i <= state.pages; i++) {
            resData.push(<span className={i === state.activePage ? 'referralStructure__tables_paginationButtonSelected' : 'referralStructure__tables_paginationButton'}
                onClick={() => searchButtonHandler(i)}>{i}</span>);
        }

        return (
            <div className="transactionCheckETH__pagination_mainWrapper">
                <div className="transactionCheckETH__pagination_wrapper">{resData}</div>
            </div>
        );
    };

    const renderFilters = () => {
        return (
            <div className="transactionCheckETH__filters_wrapper">
                <input className="transactionCheckETH__filters_input" type="text" placeholder="tx hash" value={state.txHash || ''}
                    onChange={inputChangeHandler('txHash')} />
                <input className="transactionCheckETH__filters_input" type="text" placeholder="from address" value={state.fromAddress || ''}
                    onChange={inputChangeHandler('fromAddress')} />
                <input className="transactionCheckETH__filters_input" type="text" placeholder="cashback token" maxLength="8"
                    value={state.cashbackToken || ''} onChange={inputChangeHandler('cashbackToken')} />
                <input className="transactionCheckETH__filters_input" type="text" placeholder="parent cashback token" maxLength="8"
                    value={state.parentCashbackToken || ''} onChange={inputChangeHandler('parentCashbackToken')} />
                <div>
                    <button id={'search'} onClick={searchButtonHandler}>Search</button>
                    <button style={{ marginLeft: 10 }} onClick={cleanSearchHandler}>Clean search</button>
                    <button style={{ marginLeft: 10 }} onClick={searchButtonHandler}>Update</button>
                </div>
            </div>
        );
    };

    return (
        <>
            <CheckAuth />
            <Menu />
            <div>
                {renderFilters()}
                <PageMode modesArray={MODES} checkedMode={state.mode} onChangeHandler={modeOnChangeHandler} />
                {renderTable()}
                {renderPages()}
                {renderModal()}
                <ToastContainer
                    position="top-right"
                    autoClose={2000}
                    hideProgressBar={true}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss={false}
                    draggable
                    pauseOnHover={false}
                />
            </div>
        </>
    )
}
